import { getCSRFToken } from '../lib/django';

const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

export async function getInventoryYears() {
  const res = await fetch(`${API_BASE}/api/inventory/years/`);
  if (!res.ok) throw new Error("Kunde inte hämta år");
  return await res.json();
}

export async function getInventoryItems({ location, year }) {
  const params = new URLSearchParams();
  if (location) params.set("location", location);
  if (year) params.set("year", String(year));

  const res = await fetch(`${API_BASE}/api/inventory/items/?${params.toString()}`);
  if (!res.ok) throw new Error("Kunde inte hämta inventarie");
  return await res.json();
}

export function downloadInventoryCsv({ location, year }) {
  const params = new URLSearchParams();
  if (location) params.set("location", location);
  if (year) params.set("year", String(year));

  // öppnar download i ny flik
  window.open(`${API_BASE}/api/inventory/download/?${params.toString()}`, "_blank");
}

export async function createInventoryItem(payload) {
  const res = await fetch(`${API_BASE}/api/inventory/items/`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-CSRFToken": getCSRFToken() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Kunde inte lägga till sak");
  return await res.json();
}

export async function updateInventoryItem(id, patch) {
  const res = await fetch(`${API_BASE}/api/inventory/items/${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", "X-CSRFToken": getCSRFToken() },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error("Kunde inte uppdatera sak");
  return await res.json();
}

export async function deleteInventoryItem(id) {
  const res = await fetch(`${API_BASE}/api/inventory/items/${id}/`, {
    method: "DELETE",
    headers: { "X-CSRFToken": getCSRFToken() },
  });
  if (!res.ok) throw new Error("Kunde inte radera sak");
}
